import settings from "configs/settings";
import clg from "functions/log";
import React from "react";
import { Link, useLocation, useHistory, } from "react-router-dom";

const NavbarItem = ( props ) => {

    const history = useHistory();
    const location = useLocation().pathname;
    //const isActive = ( props.to === location ? true : false );
    //const isActive = ( location.includes( props.to ) ? true : false );
    const isActive = false;
    const highlighted = ( props.highlighted ? props.highlighted : false );
    const toRef = ( props.toRef ? props.toRef : null );
    const onClick = typeof props?.onClick === "function" ? props.onClick : undefined;

    const handleOnClick = (event) => {
        return;


        console.log("handleOnClick")

        if( typeof onClick === "function" ) {
            console.log("onClickonClick")
            onClick(event);
        }


        

        clg("props.redirectIfNotOn: ", props.redirectIfNotOn)
        //Ha görgetni kell az adott elemhez
        if( props.to[0] === "#" && toRef ) {
            event.preventDefault();
            
            if( !props.redirectIfNotOn ) {
                //Ha nem kell átirányítani, mert minden oldalon megtalálható a komponens (pl: footer-kapcsolat)
                toRef.current.scrollIntoView();
            }
            if( props.redirectIfNotOn ) {
                //Ha csak az egyik oldalon elérhető a komponens, akkor át kell irányítnai HA nem azon az oldalon vagyunk ahol elérhető(pl: főoldal-bemutatkozás);
                //clg("___________________________", location, props.redirectIfNotOn)
                if( location ===  props.redirectIfNotOn) {
                    //Ha azon az oldalon vagyunk ahol a komponens elérhető
                    toRef.current.scrollIntoView();

                    console.log("______toRef.current_______> ", toRef.current);

                } else {
                    //Ha nem azon az oldalon vagyunk ahol a komponens elérhető
                    const to = props.to.split("#");

                    console.log("______to[to.length-2]_______> ", to[to.length-2], toRef.current)

                    history.push(to[to.length-2]);
                    setTimeout(() => {
                        toRef.current.scrollIntoView();
                    },1000);
                }
            }

        } else {
            //Ha linkelni kell egy másik oldalra
            props.onClick();
        }
    }

    return (
        <li className={ (isActive ? "active" : "") + (highlighted ? " highlighted" : "") }>
            <Link to={ props.to } className={ props.className } onClick={(e) => typeof onClick === "function" ? onClick(e) : undefined} >{ props.title }</Link>
        </li>
    )
}

export default NavbarItem;